/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import Survey from "components/survey/Survey";
import {Trans} from "react-i18next";

class SurveysTable extends Component {
  state = {
    sort_by: "trName", // training name by default
    sort_dir: "desc",
  };

  trName = "";
  trSubject = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trName = "";
    this.trSubject = "";

    switch (this.state.sort_by) {
      case "trName":
        this.trName = `_${this.state.sort_dir}`;
        break;
      case "trSubject":
        this.trSubject = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = () => {
  
    const sorted = this.props.data.sort((a,b) => {
      switch (this.state.sort_by) {
        case "trName":
          return this.state.sort_dir === "desc"
            ? a.survey.name.localeCompare(b.survey.name)
            : b.survey.name.localeCompare(a.survey.name);
        case "trSubject":
          return this.state.sort_dir === "desc"
            ? a.subject.localeCompare(b.subject)
            : b.subject.localeCompare(a.subject);
        default:
          return this.state.sort_dir === "desc"
            ? a.survey.name.localeCompare(b.survey.name)
            : b.survey.name.localeCompare(a.survey.name);
      }
    })

    return sorted.map((s) => {
      return (
        <Survey key={s.inviteId} survey={s} fullname={this.props.fullname} />
      );
    });
  };

  render() {
    this.setSotingClassNames();
    return (
      <div
        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        id="kayitliEgitimler"
        style={{ display: "block" }}
      >
        <table
          className="table display responsive dataTable no-footer dtr-none collapsed"
          id="dataTablePersonel"
        >
          <thead>
            <tr>
              <th
                onClick={() => this.reOrder("trName")}
                className={`all sorting${this.trName}`}
              >
                <div className="tableTitle"><Trans desc="Adı">10186</Trans></div>
              </th>
              <th
                onClick={() => this.reOrder("trSubject")}
                className={`desktop sorting${this.trSubject}`}
              >
                <div className="tableTitle"><Trans desc="Açıklaması">10187</Trans></div>
              </th>
            </tr>
          </thead>
          <tbody>
            {this.renderData()}
            {/* {console.log(props.data)} */}
          </tbody>
        </table>
      </div>
    );
  }
}

export default SurveysTable;
